export default "__VITE_ASSET__CXMPz4N7__"